<template>
  <div class="d-flex flex-column flex h100">
    <navbar></navbar>
    <div class="app">
      <config-sidenav></config-sidenav>
      <div v-if="approving" id="content" class="app-content box-shadow-3">
        <assessment-approve :assessment="sAssessment"></assessment-approve>
      </div>
      <div v-if="!approving" id="content" class="app-content box-shadow-3">
        <!-- Optional navbar at top of page -->
        <div class="navbar navbar-expand-lg">
          <!-- Page title -->
          <div class="navbar-text nav-title flex" id="pageTitle">Pending Assessment</div>
          <!-- Show inactive -->
          <div class="checkbox mr-3">
            <label class="md-check">
              <input v-model="showInProgress" type="checkbox" />
              <i class="theme-accent"></i>
              Hide InProgress
            </label>
          </div>
          <!-- Search field -->
          <div>
            <form class="input-group m-2 my-lg-0">
              <span class="input-group-btn">
                <button type="button" class="btn no-border no-bg no-shadow">
                  <i class="fa fa-search"></i>
                </button>
              </span>
              <input
                type="text"
                v-model="filter"
                class="form-control"
                placeholder="Search assessments..."
              />
            </form>
          </div>
        </div>

        <div class="content-main">
          <div class>
            <!-- Page content goes here -->
            <b-table
              v-if="renderComponent"
              ref="table"
              responsive="lg"
              striped
              hover
              :show-empty="true"
              :items="provider"
              :fields="table_fields"
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
            >
              <!-- Name -->
              <template slot="name" slot-scope="data">
                <div
                  class="constrained-cell"
                  v-tippy="{ interactive: true }"
                  :title="data.item.name"
                >{{ data.item.name }}</div>
              </template>
              <!-- Template -->

              <template slot="template_id" slot-scope="data">
                <div
                  class="constrained-cell"
                  v-tippy="{ interactive: true }"
                  :title="getTemplateName(data.item.template_id)"
                >{{ getTemplateName(data.item.template_id) }}</div>
              </template>

              <!-- Item count -->
              <template slot="items" slot-scope="data">{{ data.item.items.length }}</template>

              <!-- Rubric name
							<template slot="rubric" slot-scope="data">
								<span v-tippy :title="data.item.rubric.name">
									{{data.item.rubric.name}}
								</span>
              </template>-->
              <template slot="user" slot-scope="data">
                <div v-if="data.item.user" class="constrained-cell">
                  <span >{{data.item.user.full_name}}</span>
                </div>
              </template>
              <template slot="district" slot-scope="data">
                <div v-if="data.item.district" class="constrained-cell">
                  <span >{{data.item.district.name}}</span>
                </div>
                <!-- <div v-if="!data.item.feedback" class="constrained-cell" v-tippy="{ interactive: true }" title="Pending Approval">
									{{data.item.status}}
                </div>-->
              </template>
              <template slot="status" slot-scope="data">
                <div v-if="data.item.status" class="constrained-cell">
                  <span v-if="data.item.status == 'Submitted'">Waiting For Review</span>
                  <span v-if="data.item.status != 'Submitted'">{{data.item.status}}</span>
                </div>
                <!-- <div v-if="!data.item.feedback" class="constrained-cell" v-tippy="{ interactive: true }" title="Pending Approval">
									{{data.item.status}}
                </div>-->
              </template>
              <!-- Actions -->
              <template slot="actions" slot-scope="data">
                <nobr>
                  <div class="mx-auto w90" style="text-align : center">
                    <a
                      v-if="user.role.page_approve_assessment"
                      :href="`#/assessmentapprove/${data.item.id}`"
                      class="btn btn-sm btn-icon btn-rounded theme-accent m-0"
                      v-tippy
                      title="Edit this assessment"
                    >
                      <i class="far fa-edit"></i>
                    </a>
                    <button
                      v-if="!data.item.inProgress && user.role.page_approve_assessment"
                      @click="deleting = data.item"
                      class="btn btn-sm btn-icon btn-rounded red text-white m-0"
                      v-tippy
                      title="Delete this assessment"
                    >
                      <i class="far fa-trash"></i>
                    </button>
                    <button
                      v-if="data.item.inProgress"
                      class="btn btn-sm btn-icon btn-rounded m-0"
                      v-tippy
                      title="Removing..."
                    >
                      <loading type="icon" />
                    </button>
                  </div>
                </nobr>
              </template>

              <template slot="empty">
                <loading type="table" v-if="loading" />
                <div v-if="!loading">There are no records to show</div>
              </template>
            </b-table>
          </div>
        </div>

        <div class="p-1 b-t mt-auto white d-flex flex-row align-items-center">
          <a class="flex mx-3">
            Page {{ totalRows > 0 ? currentPage : 0 }} of {{ Math.ceil(totalRows / perPage) }} ({{
            totalRows
            }})
          </a>
          <div>
            <b-pagination
              size="md"
              class="m-1"
              :total-rows="totalRows"
              v-model="currentPage"
              :per-page="perPage"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="deleteConfirm" :visible="deleting != false" v-if="deleting">
      <template slot="modal-title">Delete Assessment</template>
      <div class="row px-4 py-2 text-md">
        <h5 class="pt-2 mb-0">
          Are you sure you want to delete the assessment
          <strong
            class="text-theme"
          >"{{ deleting.name }}"</strong>?
        </h5>
        <h5 class="py-2">
          This will have far-reaching effects, including the deletion of the following data:
          <br />
        </h5>
        <ul>
          <li class="text-theme">Administrations of this assessment in existing classes</li>
          <li class="text-theme">Student work submitted using this assessment</li>
          <li class="text-theme">Scores and comments on that work</li>
        </ul>
        <h6 class="py-2">
          <span class="text-danger far faw fa-exclamation-triangle"></span>
          The operation will occur immediately, and cannot be canceled or reversed!
        </h6>
      </div>
      <div class="form-group pl-2 pr-3">
        <input type="text" v-model="deleteConfirm" class="form-control" />
        <small class="text-muted">To confirm, type the name of the assessment</small>
      </div>
      <template slot="modal-footer">
        <button class="btn btn-flat" data-dismiss="modal">Cancel</button>
        <button
          class="btn btn-flat"
          :class="{ [deleting.name != deleteConfirm ? 'btn-secondary' : 'btn-danger']: true }"
          data-dismiss="modal"
          @click="deleteAssessment(deleting)"
          :disabled="deleting.name != deleteConfirm"
        >Delete</button>
      </template>
    </b-modal>

    <mzfooter></mzfooter>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.w40 {
  width: 40px;
}
.w90 {
  width: 90px;
}
.constrained-cell {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>

<script>
//UI Components

//Libraries

//Services
import AuthService from "@/services/AuthService";
import AssessmentService from "@/services/AssessmentService";
import TemplateService from "@/services/TemplateService";
import AssessmentApprove from "@/components/assessment/AssessmentApprove";
import store from "@/services/Store";
import Notie from "@/services/NotieService";

export default {
  name: "PendingAssessments",

  props: ["user"],
  components: {
    "assessment-approve": AssessmentApprove
  },
  data() {
    return {
      table_fields: [
        {
          key: "name",
          label: this.$i18n.t("label.name"),
          sortable: true
        },
        {
          key: "ref_id",
          label: this.$i18n.t("label.ref_id"),
          sortable: true
        },

        {
          key: "template_id",
          label: "template",
          // thStyle: { "text-align": "center" },
          tdClass: "p-custom p-0 v-mid switch-fix",
          sortable: true
        },
        {
          key: "user",
          label: "User",
          sortable: true
        },
        {
          key: "district",
          label: "District",
          sortable: true
        },
        {
          key: "status",
          label: "Status",
          sortable: true
        },
        {
          key: "actions",
          label: this.$i18n.t("label.actions"),
          thStyle: { "text-align": "center" },
          tdClass: "p-custom p-0 v-mid"
        }
      ],
      currentPage: 1,
      perPage: 15,
      templates: [],
      totalRows: 0,
      filter: "",
      active: false,
      sortBy: null,
      sortDesc: false,
      showInProgress: false,
      loading: true,
      deleting: false,
      approving: false,
      renderComponent: true,
      sAssessment: {},
      deleteConfirm: "",
      assessments: null
    };
  },

  created() {
    this.sortBy = store.get(this, "items.sortBy");
    this.sortDesc = store.getDefault(this, "items.sortDesc", false);
    this.showInactive = store.getDefault(this, "items.showInactive", true);
    this.forceRerender();
  },

  watch: {
    sortBy() {
      store.set(this, "items.sortBy", this.sortBy);
    },
    sortDesc() {
      store.set(this, "items.sortDesc", this.sortDesc);
    },
    showInactive() {
      store.set(this, "items.showInactive", this.showInactive);
      this.refreshTable();
    },
    showInProgress() {
      store.set(this, "rubrics.showInProgress", this.showInProgress);
      console.log("refreshing");
      this.refreshTable();
    }
  },

  methods: {
    provider(ctx) {
      ctx.active = this.showInProgress;
      return AssessmentService.listTempAssessments(ctx)
        .then(resp => {
          this.totalRows = resp.data.totalRows;
          this.assessments = resp.data.assessments;
          this.LoadTemplates();
          return resp.data.assessments;
        })
        .catch(err => {
          console.log(err);
          Notie.error("Failed to load assessments", err);
          return [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    OpenApprove(item) {
      this.sAssessment = item;
      this.approving = true;
    },
    LoadTemplates() {
      return TemplateService.listTemplates()
        .then(resp => {
          console.log("Got templates", resp.data);
          this.templates = resp.data.templates;
        })
        .catch(err => {
          console.log(err);
          Notie.error("Failed to Get Templates", err);
        });
    },
    forceRerender() {
      // Remove my-component from the DOM
      this.renderComponent = false;
      this.$nextTick(() => {
        // Add the component back in
        this.renderComponent = true;
      });
    },
    setActive(item) {
      if (item.active) {
        AssessmentService.activateAssessment(item.id)
          .then(resp => {
            Notie.success("Assessment marked as active");
            this.refreshTable();
          })
          .catch(err => {
            console.log(err);
            Notie.error("Failed to activate assessment", err);
            item.active = false;
          });
      } else {
        AssessmentService.deactivateAssessment(item.id)
          .then(resp => {
            Notie.success("Assessment marked as inactive");
            this.refreshTable();
          })
          .catch(err => {
            console.log(err);
            Notie.error("Failed to deactivate assessment", err);
            item.active = true;
          });
      }
    },
    getTemplateName(id) {
      return this.templates.find(element => element.id == id)["name"];
    },
    deleteAssessment(asmt) {
      asmt.inProgress = true;
      AssessmentService.removeTempAssessment(asmt.id)
        .then(resp => {
          Notie.info("Assessment deleted");
          this.refreshTable();
        })
        .catch(err => {
          Notie.error("Failed to delete assessment", err);
        })
        .finally(() => {
          item.inProgress = false;
          this.$forceUpdate();
        });
      this.deleting = false;
    },

    refreshTable() {
      this.$refs.table.refresh();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/vues/SetupConfig/PendingAssessments.vue